import React from 'react';
import Icon from '../../../components/AppIcon';

const TabNavigation = ({ activeTab, onTabChange, counts }) => {
  const tabs = [
    { id: 'products', label: 'Produtos', icon: 'Package', count: counts?.products },
    { id: 'kits', label: 'Kits', icon: 'Box', count: counts?.kits },
    { id: 'grouped', label: 'Produtos Agrupados', icon: 'Grid', count: counts?.grouped },
  ];

  return (
    <div className="border-b border-border bg-card rounded-t-lg">
      <div className="flex overflow-x-auto">
        {tabs?.map(tab => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            className={`flex items-center gap-2 px-6 py-4 text-sm font-medium transition-smooth border-b-2 ${
              activeTab === tab?.id
                ? 'border-primary text-primary bg-primary/5' :'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted/50'
            }`}
          >
            <Icon name={tab?.icon} size={18} />
            <span>{tab?.label}</span>
            {tab?.count > 0 && (
              <span className={`ml-2 px-2 py-0.5 rounded-full text-xs ${
                activeTab === tab?.id ? 'bg-primary text-white' : 'bg-muted text-muted-foreground'
              }`}>
                {tab?.count}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabNavigation;